// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  NotificationType,
} from "./types";


export default __t.row({
  notificationId: __t.u64().primaryKey().name("notification_id"),
  userIdentity: __t.identity().name("user_identity"),
  get notificationType() {
    return NotificationType.name("notification_type");
  },
  title: __t.string(),
  message: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  dismissed: __t.bool(),
});
